/**
 * backGuard - keep the user inside the SPA when they press the browser Back
 * button. On load we seed the history stack with dummy entries, and on every
 * `popstate` (Back/Forward) we immediately push a fresh entry so navigation
 * never escapes the page.
 *
 * This is a UI-only side-effect; call once at startup. Returns a disposer.
 */
const SEED_COUNT = 10;

export function installBackGuard({ seedCount = SEED_COUNT } = {}) {
  if (typeof window === 'undefined' || !window.history) return () => {};

  const pushDummy = () => {
    try {
      window.history.pushState({ _guard: true }, document.title, window.location.href);
    } catch (e) {
      console.error(e);
    }
  };

  // Seed the stack so the first few Back presses have somewhere to land.
  try {
    if (window.history.length < seedCount) {
      for (let i = 0; i < seedCount; i++) pushDummy();
    }
  } catch (e) {
    console.error(e);
  }

  // Whenever the user navigates back, re-push to trap them on the page.
  const onPopState = () => pushDummy();
  window.addEventListener('popstate', onPopState);

  return () => window.removeEventListener('popstate', onPopState);
}
